<section>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Vendor</li>
            <li class="breadcrumb-item active">DVMS System Alerts</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text">
                            <img src="../../../../assets/img/system-alerts.png" width="23px" height="23px">
                            &nbsp; DVMS System Alerts</span>
                        <button style="height: 30px !important;width: auto!important;
                        margin-top: -3px;border-color: white;" pButton icon="pi pi-plus" type="button"
                            label="Add Alerts" class="p-button-sm p-button-success float-right"
                            (click)="AddAlertsDialog=true;addSystemAlert()"
                            *ngIf="sharedService.checkPermission('Admin_Add')"></button>
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <button [ngClass]="showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                            <button [ngClass]="showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                            <button [ngClass]="showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                        </div>
                        <div class="col-md-4">
                        </div>
                        <div class="col-md-4">
                            <button pButton label="Export" *ngIf="sharedService.checkPermission('Admin_Export')"
                                (click)="exportDvmsSystemAlerts()"class="p-button-raised  m-2" icon="pi pi-file-excel" type="button"
                                style="float: right;height: 30px;"></button>
                            <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash"
                                (click)="clearFilter(dt2)" style="float: right;height: 30px;"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="card">
        <div class="card-body">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                </div>
                <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                </div>

                <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                    <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns"
                        maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected"
                        optionLabel="header" [showHeader]="false" [showClear]="false"
                        (onChange)="showAndHideColumn($event)" style="float: right;">
                        <ng-template let-column pTemplate="item">
                            <div class="column-item">
                                <div>{{column.header}}</div>
                            </div>
                        </ng-template>
                    </p-multiSelect>
                </div>
            </div>
            <div class="p-fluid">
                <p-table #dt2 [value]="dvmsSystemAlertsList" [lazy]="true" (onLazyLoad)="loadDVMSSystemAlerts($event)"
                    paginatorDropdownAppendTo="body" dataKey="id" [rows]="10" [showCurrentPageReport]="true"
                    [resizableColumns]="true" columnResizeMode="expand" [rowsPerPageOptions]="[10,25,50,100,250,500,1000]"
                    [scrollable]="true" scrollHeight="350px" [loading]="loading" styleClass="p-datatable-gridlines"
                    [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [globalFilterFields]="['action','alertName','alertPageName']">
                    <ng-template pTemplate="colgroup" let-columns>
                        <colgroup [attr.colspan]="selectedColumns.length">
                            <col style="width: 5rem" *ngIf="isShowColumns('action')">
                            <col [ngStyle]="{'width':setColumnWidth(10)}" *ngIf="isShowColumns('alertPageName')">
                            <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('alertName')">
                            <!-- <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('alertTitle')"> -->
                            <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('alertMessage')">
                            <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('startDate')">
                            <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('endDate')">
                            <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isActive')">
                            <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('createdByName')">
                            <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('createdOn')">
                            <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('modifiedByName')">
                            <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('modifiedOn')">




                        </colgroup>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(4)}"
                                *ngIf="isShowColumns('action') && sharedService.checkPermission('Admin_Add')"
                                style="width: 5rem">Action</th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('alertPageName')">Alert Page<span
                                    pSortableColumn="alertPageName" *ngIf="showSorting">
                                    <p-sortIcon field="alertPageName"></p-sortIcon>
                                </span>
                                <app-basic-filter [hidden]="!showFilters" [field]="'alertPageName'" [filters]="filters"
                                    [table]="table" (applyFilter)="applyFilterNew()">
                                </app-basic-filter>
                                <!-- <app-dropdown-filter [hidden]="!showFilters" [field]="'alertPageName'" [values]="systemAlertPageNames"
                                [optionLabel]="'description'" [optionValue]="'lookupOrder'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-dropdown-filter> -->

                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('alertName')">Alert Name<span pSortableColumn="alertName"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="alertName"></p-sortIcon>
                                </span>
                                <app-basic-filter [hidden]="!showFilters" [field]="'alertName'" [filters]="filters"
                                    [table]="table" (applyFilter)="applyFilterNew()">
                                </app-basic-filter>
                            </th>
                            
                            <!-- <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('alertTitle')">Alert Title<span pSortableColumn="alertTitle"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="alertTitle"></p-sortIcon>
                                </span>
                                <app-basic-filter [hidden]="!showFilters" [field]="'alertTitle'" [filters]="filters"
                                    [table]="table" (applyFilter)="applyFilterNew()">
                                </app-basic-filter>
                            </th> -->
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('alertMessage')">Alert Message
                                <!-- <span pSortableColumn="alertMessage"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="alertMessage"></p-sortIcon>
                                </span>
                                <app-basic-filter [hidden]="!showFilters" [field]="'alertMessage'" [filters]="filters"
                                    [table]="table" (applyFilter)="applyFilterNew()">
                                </app-basic-filter> -->
                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('startDate')">Start Date & Time<span pSortableColumn="startDate"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="startDate"></p-sortIcon>
                                </span>

                                <app-date-filter [hidden]="!showFilters" [field]="'startDate'" [filters]="filters"
                                    [table]="table" (filterDate)="startDateFilterData($event)"
                                    [filterData]="startDateFilterValue"></app-date-filter>

                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('endDate')">End Date & Time<span pSortableColumn="endDate"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="endDate"></p-sortIcon>
                                </span>

                                <app-date-filter [hidden]="!showFilters" [field]="'endDate'" [filters]="filters"
                                    [table]="table" (filterDate)="endDateFilterData($event)"
                                    [filterData]="endDateFilterValue"></app-date-filter>

                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}"
                                *ngIf="isShowColumns('isActive')">Status <span pSortableColumn="isActive"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="isActive"></p-sortIcon>
                                </span>

                                <app-isactive-filter [hidden]="!showFilters" [field]="'isActive'"
                                    [values]="statusValues" [optionLabel]="'description'" [optionValue]="'id'"
                                    [filters]="filters" [table]="table" (applyFilter)="applyFilterNew()">
                                </app-isactive-filter>

                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('createdByName')">Created By<span pSortableColumn="createdByName"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="createdBy"></p-sortIcon>
                                </span>
                                <app-basic-filter [hidden]="!showFilters" [field]="'createdByName'" [filters]="filters"
                                    [table]="table" (applyFilter)="applyFilterNew()">
                                </app-basic-filter>
                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('createdOn')">Created On<span pSortableColumn="createdOn"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="createdOn"></p-sortIcon>
                                </span>

                                <app-date-filter [hidden]="!showFilters" [field]="'createdOn'" [filters]="filters"
                                    [table]="table" (filterDate)="createdOnFilterData($event)"
                                    [filterData]="createdOnFilterValue"></app-date-filter>

                            </th>

                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('modifiedByName')">Modified By<span
                                    pSortableColumn="modifiedByName" *ngIf="showSorting">
                                    <p-sortIcon field="modifiedByName"></p-sortIcon>
                                </span>
                                <app-basic-filter [hidden]="!showFilters" [field]="'modifiedByName'" [filters]="filters"
                                    [table]="table" (applyFilter)="applyFilterNew()">
                                </app-basic-filter>
                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                                *ngIf="isShowColumns('modifiedOn')">Modified On<span pSortableColumn="modifiedOn"
                                    *ngIf="showSorting">
                                    <p-sortIcon field="modifiedOn"></p-sortIcon>
                                </span>

                                <app-date-filter [hidden]="!showFilters" [field]="'modifiedOn'" [filters]="filters"
                                    [table]="table" (filterDate)="modifiedOnFilterData($event)"
                                    [filterData]="modifiedOnFilterValue"></app-date-filter>

                            </th>


                        </tr>
                        <tr [hidden]="!showFilters">
                            <th *ngIf="isShowColumns('action') && sharedService.checkPermission('Admin_Add')">
                            </th>
                            <th *ngIf="isShowColumns('alertPageName')">
                                {{filters?.alertPageName[0]?.value}}
                            </th>
                            <th *ngIf="isShowColumns('alertName')">{{filters?.alertName[0]?.value}}
                            </th>
                            <!-- <th *ngIf="isShowColumns('alertTitle')">
                                {{filters?.alertTitle[0]?.value}}</th> -->
                            <th *ngIf="isShowColumns('alertMessage')">
                                <!-- {{filters?.alertMessage[0]?.value}} -->
                            </th>
                            <th *ngIf="isShowColumns('startDate')">
                                <div *ngIf="startDateFilterValue != undefined">
                                    {{startDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}}
                                    <span *ngIf="startDateFilterValue.length > 1">-</span>
                                    {{startDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                                </div>
                            </th>
                            <th *ngIf="isShowColumns('endDate')">
                                <div *ngIf="endDateFilterValue != undefined">
                                    {{endDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span
                                        *ngIf="endDateFilterValue.length > 1">-</span>
                                    {{endDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                                </div>
                            </th>
                            <th *ngIf="isShowColumns('isActive')">{{selectedHasAvailableStatus}}
                            </th>
                            <th *ngIf="isShowColumns('createdByName')">
                                {{filters?.createdByName[0]?.value}}
                            </th>
                            <th *ngIf="isShowColumns('createdOn')">
                                <div *ngIf="createdOnFilterValue != undefined">
                                    {{createdOnFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}}
                                    <span *ngIf="createdOnFilterValue.length > 1">-</span>
                                    {{createdOnFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                                </div>
                            </th>
                            <th *ngIf="isShowColumns('modifiedByName')">
                                {{filters?.modifiedByName[0]?.value}}</th>
                           
                            <th *ngIf="isShowColumns('modifiedOn')">
                                <div *ngIf="modifiedOnFilterValue != undefined">
                                    {{modifiedOnFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}}
                                    <span *ngIf="modifiedOnFilterValue.length > 1">-</span>
                                    {{modifiedOnFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                                </div>
                            </th>
                           
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-dvmsSystemAlertsList>
                        <tr>
                            <td [ngStyle]="{'width':setColumnWidth(4)}"
                                *ngIf="isShowColumns('action') && sharedService.checkPermission('Admin_Add')">
                                <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                        (click)="selectedGridMenuItem = dvmsSystemAlertsList; menu.toggle($event)"></i></a>
                                <p-menu #menu [popup]="true" [model]="items" appendTo="body">
                                </p-menu>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('alertPageName')">
                                <span>{{dvmsSystemAlertsList.alertPageName}}</span>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('alertName')">
                                <span>{{dvmsSystemAlertsList.alertName}}</span>
                            </td>
                            <!-- <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('alertTitle')">
                                <span>{{dvmsSystemAlertsList.alertTitle}}</span>
                            </td> -->
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('alertMessage')">
                                <span>{{dvmsSystemAlertsList.alertMessage}}</span>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('startDate')">
                                <span>{{dvmsSystemAlertsList.startDate | date:'MM/dd/yy h:mm:ss a'}}</span>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('endDate')">
                                <span>{{dvmsSystemAlertsList.endDate 
                                    | date:'MM/dd/yy h:mm:ss a'}}</span>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isActive')">
                                <span class="customer-badge status-active"
                                    *ngIf="dvmsSystemAlertsList.isActive">Active</span>
                                <span class="customer-badge status-inactive"
                                    *ngIf="!dvmsSystemAlertsList.isActive">Inactive</span>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('createdByName')">
                                <span>{{dvmsSystemAlertsList.createdByName}}</span>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('createdOn')">
                                <span>{{dvmsSystemAlertsList.createdOn |
                                    date:'MM/dd/yyyy'}}</span>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('modifiedByName')">
                                <span>{{dvmsSystemAlertsList.modifiedByName}}</span>
                            </td>
                            <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('modifiedOn')">
                                <span>{{dvmsSystemAlertsList.modifiedOn |
                                    date:'MM/dd/yyyy'}}</span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="selectedColumns.length">No DVMS system alerts found.
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</section>
<p-dialog id="addDVMSSystemAlert" class="systemAlertDialog" [showHeader]="false" [(visible)]="AddAlertsDialog"
    [modal]="true" style="height:10px!important;" [style]="{height:'100%'}" [draggable]="true" [resizable]="false"
    [closable]="false">
    <div class="p-dialog-header">
        <span class="p-dialog-title">{{dialogTitle}}</span>
        <div class="p-dialog-header-icons">
            <button type="button" class="p-dialog-header-icon p-dialog-header-maximize p-link"
                (click)="AddAlertsDialog=false;closeAlertsDialog()"><span
                    class="p-dialog-header-close-icon pi pi-times"></span></button>
        </div>
    </div>
    <div style="padding: 0px 20px 20px 20px;">

        <form [formGroup]="alertsForm">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4">
                    <label for="alertName">Alert Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="alertName" type="text" pInputText>
                    <span class="text-danger"
                        *ngIf="(alertsFormControl.alertName.touched) && alertsFormControl.alertName.errors?.required">
                    </span>
                </div>
                <div *ngIf="isAdd" class="p-field p-col-12 p-md-4">
                    <label for="alertPageName">Alert Page<span class="required-field">*</span></label>
                     <p-multiSelect [options]="pageNames" 
                            (onChange)="getAlertPageNameOnChangeAdd($event)" [(ngModel)]="selectedPageNameId"
                            [ngModelOptions]="{standalone: true}" defaultLabel="Select pages"
                            optionLabel="description" display="chip"></p-multiSelect>
                   
                </div>
                <div *ngIf="!isAdd" class="p-field p-col-12 p-md-4">
                    <label for="alertPageName">Alert Page<span class="required-field">*</span></label>
                   
                    <p-dropdown (onChange)="getAlertPageNameOnChangeEdit($event)" [options]="pageNames" placeholder="Select"
                        optionLabel="description" [(ngModel)]="selectedPageNameId"
                        [ngModelOptions]="{standalone: true}">
                    </p-dropdown>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label> Start Date & Time<span class="required-field">*</span></label>
                    <p-calendar #startDate id="alert-startdatecalendar" [showIcon]="true" type="date"
                        formControlName="startDate" [minDate]="minDate" [showTime]="true" hourFormat="12" (onSelect)="onSelectStartDate($event)"
                        [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
                    </p-calendar>

                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label> End Date & Time<span class="required-field">*</span></label>
                    <p-calendar #endDate [showIcon]="true" type="date" formControlName="endDate"  [minDate]="endDate_Start"
                        [showTime]="true" hourFormat="12" [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="2000:2099" inputId="navigators">
                    </p-calendar>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="contractTohire">IsActive</label><br />
                    <p-inputSwitch formControlName="isActive"></p-inputSwitch>

                </div>
                <div class="p-field p-col-12 p-md-12">
                    <label for="alertPageName">Alert Message<span class="required-field">*</span></label>
                    <textarea formControlName="alertMessage" maxlength="1000" pInputTextarea
                        class="form-control"></textarea>
                </div>
            </div>
        </form>
        <br><br><br>
        <div class="text-right">
            <p-button icon="pi pi-times" label="Cancel" (onClick)="AddAlertsDialog=false;closeAlertsDialog()"
                [style]="{height:'30px','margin-right':'10px'}" styleClass=" p-button-danger p-button-text"></p-button>
            <p-button icon="pi pi-check" label={{buttonLabel}} [loading]="loadingSave"
                [disabled]="!this.alertsForm.valid || !alertPageNameSelected"
                (onClick)="addSystemAlertDetails(alertsForm)" [style]="{height:'30px'}"
                styleClass="p-button-text p-button-success p-mr-2" [style]="{height:'30px'}"></p-button>
        </div>
        <br><br><br>
    </div>
</p-dialog>
<p-toast [baseZIndex]="100001" position="bottom-center"></p-toast>